/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_ButtonInputs */



/**
* | output |
* | --- |
* | "Version history" |
*
* @param {Canvas_Versions_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_button = /** @type {((inputs?: Canvas_Versions_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versionsverlauf")
	return /** @type {LocalizedString} */ ("Version history")
});